<template>
  <a-modal
      class="location-picker__modal"
      title="通过链接添加"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancelParent"
    >
    <div class="modal-body">
      <ol class="usage-list">
        <li>在微信电脑版点击别人分享的位置，会自动打开浏览器</li>
        <li>复制链接</li>
        <li>粘贴链接到下方</li>
      </ol>
      <a-form-item
        :validate-status="isError ? 'error':'validating'"
        :help="isError ? helpMsg : ''"
      >
        <a-textarea
          v-model="inputValue"
          placeholder="位置链接粘贴在这里"
          :rows="8"
          :autoSize="false"
          allow-clear
          @change="onChange"
        />
      </a-form-item>

      <div v-show="locationInfo.longitude && locationInfo.latitude" class="analysis-result">
        <div><span>名称：</span>{{locationInfo.name}}</div>
        <div><span>地址：</span>{{locationInfo.address}}</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import axios from 'axios';
import config from '@/config/index';

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      isError: false,
      helpMsg: '请粘贴正确的链接',
      inputValue: '',
      locationInfo: {
        name: '',
        address: '',
        longitude: 0,
        latitude: 0,
      },
    };
  },
  methods: {
    handleCancelParent() {
      this.$emit('update:visible', false);
      Object.assign(this.$data, this.$options.data());
    },
    validateError() {
      this.locationInfo = {
        name: '',
        address: '',
        longitude: 0,
        latitude: 0,
      };

      if (this.inputValue.startsWith('http://')
        || this.inputValue.startsWith('https://')
      ) {
        this.isError = false;

        const urlObj = new URL(this.inputValue);

        const { searchParams } = urlObj;
        const result = {
          name: searchParams.get('name'),
          address: searchParams.get('addr'),
          longitude: parseFloat(searchParams.get('pointx')),
          latitude: parseFloat(searchParams.get('pointy')),
        };

        if (!result.longitude || !result.latitude) {
          this.helpMsg = '该链接获取不到位置信息';
          this.isError = true;
          return true;
        }

        this.locationInfo = result;

        // 获取具体地址
        axios.post(`${config.mapServerBaseURL}/location/regeocode`, {
          longitude: this.locationInfo.longitude,
          latitude: this.locationInfo.latitude,
        }).then((res) => {
          if (res.data.formatted_address) {
            this.locationInfo.address = res.data.formatted_address;
          }
        });

        return false;
      }
      this.helpMsg = '请粘贴以 http 或 https 开头的链接';
      this.isError = true;
      return true;
    },
    async handleOk() {
      if (!this.locationInfo.longitude || !this.locationInfo.latitude) {
        this.$message.warning('请粘贴正确的链接');
        return;
      }
      this.$emit('confirm', this.locationInfo, false);

      this.handleCancelParent();
    },
    onChange() {
      this.validateError();

      console.log('当前值', this.inputValue);
    },
  },
  mounted() {

  },
};
</script>

<style scoped>
.usage-list {
  padding: 0 16px;
  font-size: 14px;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.45);
}

.analysis-result {
  line-height: 26px;
}
</style>
